module.exports = __webpack_public_path__ + "img/dashboard_icon_arrow_down.eba8b388.svg";